import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EventsActions, EventsActionTypes } from './events.actions';
import { Category, Event } from './events.models';

// Events store
export const EVENTS_STORE_KEY = 'events';

// Interface for Events state
interface EventsState {
  events: Array<Event>;
  categories: Array<Category>;
  loadEventsSuccess: boolean;
  selectedEvent: Event;
}

// Initial state for Events
export const eventsInitialState: EventsState = {
  events: undefined,
  categories: undefined,
  loadEventsSuccess: undefined,
  selectedEvent: undefined
};

// Main events reducer function for events
export function eventsReducer(
  state = eventsInitialState,
  action: EventsActions
): EventsState {
  // Switch case statement for all the action type
  switch (action.type) {
    case EventsActionTypes.LOAD_EVENTS:
      return {
        ...state,
        events: void 0,
        loadEventsSuccess: undefined
      };

    case EventsActionTypes.LOAD_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
        loadEventsSuccess: true
      };

    case EventsActionTypes.LOAD_EVENTS_FAILED:
      return {
        ...state,
        loadEventsSuccess: false
      };

    case EventsActionTypes.LOAD_CATEGORIES:
      return {
        ...state,
        categories: void 0
      };

    case EventsActionTypes.LOAD_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload
      };

    case EventsActionTypes.SELECT_EVENT:
      return {
        ...state,
        selectedEvent: action.payload
      };

    // default action type
    default:
      return state;
  }
}

// creating selector for events, which is an array of Event
const eventsState = createFeatureSelector<EventsState>(EVENTS_STORE_KEY);

export const selectorEventsEvents = createSelector(
  eventsState,
  state => state.events
);

export const selectorEventsCategories = createSelector(
  eventsState,
  state => state.categories
);

export const selectorEventsSelectedEvent = createSelector(
  eventsState,
  state => state.selectedEvent
);

export const selectorEventsCategoryColor = (id: string) =>
  createSelector(eventsState, state => {
    const category =
      state.categories && state.categories.find(cat => cat.uuid === id);
    return (category && category.color) || '#2e2e2e';
  });
